<ion-content class="bg-color ion-content instance">
  <div class="com-content">
    <div class="content-breadcrumb">
      <ul class="breadcrumb">
        <li *ngFor="let itemList of breadcrumbList" class="breadcrumb-item">
          <a routerLink="{{ itemList.url }}">
            {{ itemList.label }}
          </a>
        </li>
      </ul>
    </div>
    <div class="content-grid">
      <mat-card class="margin-top-10">
        <mat-card-title class="mc-title">
          <h4 class="mat-title-header">Instances</h4>
        </mat-card-title>
        <mat-card-content class="mc-content">
          <div class="table-container">
            <div class="filter-container">
              <div class="button-container">
                
                <button mat-raised-button class="add-button" routerLink='/baseapp/instances/add'> Add </button>
                <div *ngIf="bubbleshow" class="box"
                  style="position:relative; margin-left: 92px;margin-top: -60px;z-index: 2;">
                  <span class="cancel-help-popup" (click)="closebubblecross()">&times;</span>
                  <p>Click "Add" button to create a Instance</p>
                  <button mat-raised-button style="float: right;" (click)="closebubble()">Got It</button>
                </div>
              </div>
            </div>
            <table mat-table matTableResponsive [dataSource]="resultdata">
              <!-- Position Column -->
              <!-- <ng-container matColumnDef="position">
            <th mat-header-cell *matHeaderCellDef> No. </th>
            <td mat-cell *matCellDef="let element"> {{element.position}} </td>
          </ng-container> -->
          
              <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef> ID </th>
                <td mat-cell *matCellDef="let element">{{element.id}} </td>
              </ng-container>

              <ng-container matColumnDef="instance">
                <th mat-header-cell *matHeaderCellDef> Instance </th>
                <td mat-cell *matCellDef="let element">{{element.instance}} </td>
              </ng-container>
              <ng-container matColumnDef="ip_address">
                <th mat-header-cell *matHeaderCellDef> IP Address </th>
                <td mat-cell *matCellDef="let element">{{element.ip_address}} </td>
              </ng-container>
              <ng-container matColumnDef="hostname">
                <th mat-header-cell *matHeaderCellDef> Hostname </th>
                <td mat-cell *matCellDef="let element">{{element.hostname}} </td>
              </ng-container>
              <ng-container matColumnDef="ssh_port">
                <th mat-header-cell *matHeaderCellDef> SSH Port </th>
                <td mat-cell *matCellDef="let element">{{element.ssh_port}} </td>
              </ng-container>
              <ng-container matColumnDef="is_default">
                <th mat-header-cell *matHeaderCellDef> Is Default </th>
                <td mat-cell *matCellDef="let element">{{element.is_default}} </td>
              </ng-container>

              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef> </th>
                <td mat-cell *matCellDef="let element">
                  <mat-icon class="icon edit" matTooltip="Edit" matTooltipPosition="above"
                    (click)="editInstance(element.id)"> edit </mat-icon>
                    <mat-icon class="icon info" matTooltip="View More" matTooltipPosition="above"
                    (click)="viewMore(element.id)"> info </mat-icon>
                  <mat-icon class="icon delete" matTooltip="Delete" matTooltipPosition="above"
                    (click)="confirmDelete(element.id)"> delete </mat-icon>
                  <!-- <mat-icon class="mat-ico info" matTooltip="View More" matTooltipPosition = "above" (click)="getUserDetails(element.id)"> info </mat-icon>
                                    <mat-icon class="mat-ico delete" matTooltip="Delete" matTooltipPosition = "above" (click)="confirmDelete(element.id)"> delete </mat-icon> -->
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="userDisplayedColumns; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: userDisplayedColumns;"></tr>
            </table>
          </div>

        </mat-card-content>
      </mat-card>
    </div>
    <app-footer></app-footer>
  </div>
</ion-content>